import { render, staticRenderFns } from "./TopBrandSales.vue?vue&type=template&id=1d8e5d90&scoped=true&"
import script from "./TopBrandSales.vue?vue&type=script&lang=js&"
export * from "./TopBrandSales.vue?vue&type=script&lang=js&"
import style0 from "./TopBrandSales.vue?vue&type=style&index=0&id=1d8e5d90&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d8e5d90",
  null
  
)

export default component.exports